"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmployeeRateTitle = exports.isEmployeeComplimentaryRate = exports.convertEmployeePrice = exports.employeeConfig = void 0;
const employeeConfig = {
    employeeMaxRooms: 1,
    employeeMaxStay: 8,
    employeeCheckInDays: 120,
    employeeRequestMaxAdults: 9,
    employeeRequestMaxChildren: 9,
    employeeRequestMaxTotal: 18,
    employeeRequestMaxRooms: 3,
    employeeRates: [
        {
            code: /^EMPCMP\d{0,2}$/i,
            maxStay: 6,
            complimentary: true,
            bookable: true,
            title: 'Discovery Nights',
        },
        {
            code: /^EMPECE\d{0,2}$/i,
            maxStay: 8,
            complimentary: false,
            bookable: true,
            title: 'Employee Experience Rate',
        },
        {
            code: /^SPREQ$/i,
            maxStay: 28,
            complimentary: false,
            bookable: false,
            title: 'Friends and Family Rate Request',
        },
    ],
};
exports.employeeConfig = employeeConfig;
const convertEmployeePrice = (price, promoCode) => {
    if (promoCode &&
        employeeConfig.employeeRates.find(empRate => {
            return empRate.complimentary && !!empRate.code.exec(promoCode);
        })) {
        return {
            amount: 0.0,
            currencyCode: price.currencyCode,
        };
    }
    return price;
};
exports.convertEmployeePrice = convertEmployeePrice;
const isEmployeeComplimentaryRate = (promoCode) => {
    return (!!promoCode &&
        !!employeeConfig.employeeRates.find(empRate => {
            return empRate.complimentary && !!empRate.code.exec(promoCode);
        }));
};
exports.isEmployeeComplimentaryRate = isEmployeeComplimentaryRate;
const getEmployeeRateTitle = (promoCode) => {
    if (!promoCode) {
        return '';
    }
    const employeeRate = employeeConfig.employeeRates.find(empRate => {
        return !!empRate.code.exec(promoCode);
    });
    if (!employeeRate) {
        return '';
    }
    return employeeRate.title;
};
exports.getEmployeeRateTitle = getEmployeeRateTitle;
